import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordCardComponent } from './change-password-card.component';

// Material imports
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    ChangePasswordCardComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    ChangePasswordCardComponent
  ]
})
export class ChangePasswordCardModule { }
